  <template>
<div class="auther_table_wrap">
  <el-table
      :data="channels"
      border
      size="medium" >
      <el-table-column
        label="排名"
        type="index"
        :index="indexMethod"
        width="110">
      </el-table-column>

      <el-table-column
        prop="keyword"
        label="关键字">
      </el-table-column>
      <el-table-column
        prop="user_count"
        label="用户数">
      </el-table-column>
      <el-table-column
        prop="week_percent"
        label="周涨幅">
      </el-table-column>
   </el-table>

</div>
</template>

<script>
import cons from '@/components/constant';
let token = localStorage.token;
export default {
  name: 'SearchTable',
  props:['channels', 'nowPage'],
   data () {
    return {

    }
  },
  methods: {
    indexMethod(index) {
      return (this.nowPage - 1)* 10 + index+1
    },
  }
}
</script>

<style scope>
.el-table th,.el-table td{
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/SearchTable.vue